<template ref="summerPayForm">
  <div>
    <b-form>
      <!-- Sponsored - added Dec.  2021 -->
      <b-form-radio style="margin-top:18px; margin-bottom:15px;" name="sponsored" v-model="form.sponsored"
        :value="false">Non-sponsored / both</b-form-radio>
      <b-form-radio style="margin-top:18px; margin-bottom:15px;" name="sponsored" v-model="form.sponsored"
        :value="true">Sponsored</b-form-radio>

      <b-form-group label="Semester" label-class="control-label workload-course-label"
        :class="{ 'invalid-group': $v.form.termId.$error }">
        <b-form-select v-model="form.termId" :required="true">
          <b-form-select-option v-for="term in terms" :value="term.termId" :key="term.termId">{{ term.description
          }}</b-form-select-option>
        </b-form-select>

        <span v-if="$v.form.termId.$error" class="span-feedback invalid-feedback">
          Please select a semester.
        </span>
      </b-form-group>

      <!-- This is not the program director, this is just the person the request is for (right now: the person who submitted the request - Marina, Dec. 2021) -->
      <!-- <b-form-group label="Faculty" label-class="control-label workload-course-label" class="mb-2">
          <autocomplete :source="usersApi" :inputClass="{ 'form-control': true, 'is-invalid': $v.form.asuriteId.$error }" :disable-input="!isSPManager"
                      resultsValue="asurite"
                      :resultsDisplay="userDisplay"
                      ref="userAutocomplete"
                      @selected="selectUser"
                      credentials="include"
                      :request-headers="requestHeaders"
                      ></autocomplete>
        <span class="span-feedback invalid-feedback" v-if="$v.form.asuriteId.$error">You must enter a name.</span>
      </b-form-group> -->

      <!-- This id the PI -->
      <b-form-group label="PI" label-class="control-label workload-course-label" class="mb-2">
        <autocomplete :source="usersApi" :inputClass="{ 'form-control': true, 'is-invalid': $v.form.asuriteId.$error }"
          :disable-input="!isSPManager" resultsValue="piAsuriteId" :resultsDisplay="userDisplay" ref="userAutocomplete"
          @selected="selectUser" credentials="include" :request-headers="requestHeaders"></autocomplete>
        <span class="span-feedback invalid-feedback" v-if="$v.form.asuriteId.$error">You must enter a name.</span>
      </b-form-group>

      <b-form-group label="Notes" label-class="control-label workload-course-label" style="margin-top: 15px;">
        <vue-editor v-model="form.notes"></vue-editor>
      </b-form-group>

      <b-form-file v-model="file1" :state="Boolean(file1)" placeholder="Choose a file or drop it here..."
        drop-placeholder="Drop file here..."></b-form-file>

    </b-form>


    <P style="padding-top:10px; margin-top:8px;">
      <b-alert show variant="warning">
        <h3>CHS Faculty Summer Policies</h3>
        <ul>
          <LI> The employee certifies that this agreement and any other summer agreements at ASU, they will not exceed
            their total allowable summer salary. 1/3 of academic appointment salary if on 9 month appointment. This
            maximum includes any compensation received from the University for other tasks such as teaching. If 100% of
            the summer is committed for a sponsored project, the employee further certifies that no other time commitments
            will be made outside of work on the project.</LI>

          <LI> PI certifies that the salary action requested is authorized and included in the sponsored project budget.
            If multiple projects with different PIs, email approvals can be attached</LI>

          <LI> PI certifies that if they are requesting a Fall course buyout, then they have the necessary grant funding
            to cover both Summer and Fall terms. Otherwise will be asked for repayment or cancellation of the course
            buyout agreement.</LI>

          <LI> The employee certifies that if they teaching during the summer, then research portion will be reduced to .5
            FTE.</LI>
        </ul>
      </b-alert>
    </P>

    <b-button variant="primary" class="pull-right my-2" @click="submit()"><font-awesome-icon icon="check" />
      Submit</b-button>

  </div>
</template>

<script>
var htmlEncode = require("js-htmlencode").htmlEncode;
var htmlDecode = require("js-htmlencode").htmlDecode;

import { mapState } from "vuex";

import * as _ from "lodash"; // eslint-disable-line no-unused-vars
import { required } from "vuelidate/lib/validators";

import termsClass from "../../api/terms.js";

import { VueEditor } from "vue2-editor";
import Autocomplete from "../../components/autocomplete";

import roleChecks from "../../misc/role-checks";
import Axios from "axios";

export default {
  mixins: [roleChecks],

  data() {
    return {
      terms: [],
      file1: null,
      notes: null,
      term: 0,
      piAsuriteId: null,

      form: {
        termId: 0,
        notes: null,
        piAsuriteId: null,
        asuriteId: 0,
        sponsored: false // must be here to properly submit the form, BUT must have a value 'true' or 'false' to match the radio button
      },

      requestHeaders: { "X-Requested-With": "XMLHttpRequest" }
    };
  },
  validations() {
    var validations = {
      form: {
        asuriteId: { required },
        termId: { required },
        sponsored: { required }
      }
    };

    return validations;
  },
  components: {
    VueEditor,
    Autocomplete
  },
  computed: {
    ...mapState({
      user: state => state.auth.user
    }),

    usersApi: function () {
      return process.env.VUE_APP_BASE_URI + "/api/employees/search?search=";
    },
    searchApi: function () {
      return process.env.VUE_APP_BASE_URI + this.apiPath;
    },
    emptyText: function () {
      return "There are no " + this.objectName + "s selected.";
    },
    placeholder: function () {
      return "Search " + this.objectName + "s";
    }
  },
  methods: {
    userDisplay: function (user) {
      return (
        user.firstName +
        " " +
        user.lastName +
        " (" +
        user.asuriteId +
        ") - " +
        (user.employeeJobs[0]
          ? user.employeeJobs[0].title +
          " - " +
          user.employeeJobs[0].department.description
          : "")

        // user.department +
        // " - " +
        // user.title
      );
    },
    selectUser: function (autoselectResponse) {
      this.form.piAsuriteId = autoselectResponse.selectedObject.asuriteId;
    },
    submit: function () {
      this.$v.form.$touch();

      if (!this.$v.form.$error) {
        if (this.form.notes) {
          this.form.notes = htmlEncode(this.form.notes);
        }
        var files = [];
        files.push(this.file1);

        // CANNOT have this - prevents form submission
        // this.form.sponsored = this.sponsored;

        this.$emit("submit", { form: this.form, files: files });
      }
    },
    setForm: function (summerpay) {
      // set values
      this.form = summerpay;
    },
    loadForm(item) {
      if (item) {
        this.form = _.clone(item);
        if (this.form.description) {
          this.description = htmlDecode(this.form.description);
        }

        // this.$refs.userAutocomplete.display = this.userDisplay(this.user);

        //   this.form.primaryInvestigator.firstName +
        //   " " +
        //   this.form.primaryInvestigator.lastName +
        //   " (" +
        //   this.form.primaryInvestigatorId +
        //   ")";
      }
    }
  },
  mounted() {
    this.form.asuriteId = this.user.userId;
    this.form.piAsuriteId = this.user.userId;

    this.$refs.userAutocomplete.display = this.user.fullName;
  },
  created() {
    this.terms = Array();
    var currYear = new Date().getFullYear();

    termsClass
      .getCurrentAndFutureTerms()
      .then(response => {
        _.filter(response.data, term => {
          if (
            term["termCode"].endsWith("4") &&
            term["termStart"].substr(0, term["termStart"].indexOf("-")) ==
            currYear
          )
            this.terms.push(term);
        });
      })
      .catch(function (error) {
        console.log("Error: ");
        console.log(error);
      });

    this.loadForm(this.form);
  },
  watch: {
    value: function () {
      if (this.value) {
        this.$v.form.$touch();

        if (!this.$v.form.$error) {
          this.$emit("complete", this.form);
          this.$v.$reset();

          this.form = {
            id: 0,
            notes: null
          };
        } else {
          this.$emit("input", false);
        }
      }
    }
  }
};
</script>

<style scoped></style>
